export const OPINION_ID = 'Kanaat';
